import React from 'react';
import img1 from "../assets/img/bandeau.jpg";

export const Remerciements = () => {

    return (
        <>
            <div className="banner-titre-container">
                <img src={img1} className="back-img" />
                <div className='over-banner'>
                    <div className='info-banner'>
                        <h1 className='banner-title'> Merci </h1>
                    </div>
                </div>
            </div>
            <div className='single-container side-space bottom-space thanks-container top-space-margin'>
                <h2 align="center" class="style5" className='title-remerciements'>Je remercie toutes ces personnes qui m'ont offert leur temps et leurs talents :</h2>
                <ul>
                    <li class="style6">Nathalie Conné : 			Organisation des contenus</li><p></p><p>
                    </p><li class="style6">Laurence Bonnet :			Photo Jane, page d'accueil</li><p></p><p>
                    </p><li class="style6">Elizabeth Fiser-Braut :		Photo Louna</li><p></p><p>
                    </p><li class="style6">Jéremy Godreau : 		Illustration maquette couverture Rim-la-Belle</li><p></p><p>
                    </p><li class="style6">Stéphane Koch :			Photo Bébé-Boule-de-Joie</li><p></p><p>
                    </p><li class="style6">Catherine Mayet / Irisame :	Photos Méditation et Ilyes</li><p></p><p>
                    </p><li class="style6">Pascale Mariotte : 			Photo Jane, Qui Suis-je ? Conseils &amp; relecture</li><p></p><p>
                    </p><li class="style6">Vincent Paul Reyal : 		Photo Accueil des Nouveaux-nés, Mathis</li><p></p><p>
                    </p><li class="style6">Olga Zschunke :			Photo Passage d'âmes, Parc National Huerquehue, Chili</li><p></p><p>
                    </p><li class="style6">Claudine Paganini : 		Relecture &amp; éclairages spirituels</li><p></p><p>
                    </p><li class="style6">Carole Claire Finlay : 		Traduction</li><p></p><p>
                    </p><li class="style6">Nadia : 			Création site &amp; mises à jour</li></ul>
            </div>
        </>
    );
}

